import {DTemplate} from './DTemplate.js';

export class VenueFullPopup extends Object {
	constructor() {
		super();
		var [style, _] = DTemplate(`VenueFullPopup_style`);
		document.head.appendChild(style);
		[this.el, this.$] = DTemplate(`VenueFullPopup`);
		// console.log(`VenueFullPopup - listening for ticket notification`);
		document.addEventListener(`veedo-ticket`, evt=>{
			VenueFullPopup.instance()[ evt.detail ? 'hide' : 'show']();
		});
	}
	static instance() {
		if (!window.venueFullPopup_instance) {
			window.venueFullPopup_instance = new VenueFullPopup();
		}
		return window.venueFullPopup_instance;
	}
	show() {
		document.body.appendChild(this.el);
	}
	hide() {
		this.el.remove();
	}
}

new VenueFullPopup();